/**
 * The number of days before a team's vacation starts during which
 * the team is protected from being challenged. This prevents
 * unfair challenges right before a team goes on vacation.
 */
export const VACATION_PROTECTION_DAYS = 7;

/**
 * The number of days before a tournament ends during which the tower is
 * "locked": new challenges can no longer be created and teams can no longer
 * join the active tournament. Keeps the final week settled.
 */
export const CHALLENGE_LOCK_DAYS = 7;

/**
 * Sentinel tournament ID used for application-wide notifications.
 * These notifications are not scoped to any tournament and are visible to all users.
 */
export const APPLICATION_TOURNAMENT_ID = "__application__";

/**
 * The number of days after match completion before the match chat
 * is archived. During this period players can still access the chat.
 */
export const CHAT_ARCHIVE_DELAY_DAYS = 7;
